import React from 'react';
import PropTypes from 'prop-types';
import { TextField, makeStyles } from '@material-ui/core';
/* eslint-disable indent,import/prefer-default-export */
import fr from 'facet-rest';
import RTEWithLabel from '../Components/UI/Overrides/RTEWithLabel';

const useStyles = makeStyles(() => ({
  fullWidth: {
    width: '100%',
  },
}));


const MultiLineTextField = ({ onChange, value }) => {
const classes = useStyles();
return (
  <TextField
    classes={{
      root: classes.fullWidth,
    }}
    rows={5}
    multiline
    value={value}
    onChange={onChange}
    label="Note"
  />
  );
};
MultiLineTextField.propTypes = {
  onChange: PropTypes.func.isRequired,
  value: PropTypes.string.isRequired,
};
const hiddenFieldNames = ['householdId', 'percentComplete', 'amountSaved'];

export const GoalOverride = fr.metaOverride()
  .nameOverride('notes', { _component: () => MultiLineTextField })
  .nameOverride(name => hiddenFieldNames.includes(name), { hidden: true });

const clientGoalsPageAndBannerHiddenFields = ['householdId', 'status', 'timeHorizonType', 'timeHorizonValue', 'icon'];
export const GoalOverrideClientGoalsPageAndBanner = fr.metaOverride()
  .nameOverride('notes', { _component: () => MultiLineTextField })
  .nameOverride(clientGoalsPageAndBannerHiddenFields, { hidden: true })
  .nameOverride('name', { ordinal: 1 })
  .nameOverride('type', { ordinal: 2 })
  .nameOverride('description', { ordinal: 3 })
  .nameOverride('amount', { ordinal: 4 })
  .nameOverride('amountSaved', { ordinal: 5 })
  .nameOverride('percentComplete', { ordinal: 6 })
  .nameOverride('endDate', {
    _customProps: {
      openTo: 'year',
    },
    prompt: 'End date',
  })
  .nameOverride('description', {
    _component: () => RTEWithLabel,
    _customProps: {
      size: 'sm',
      label: 'Description',
    },
  });
